// JS for block-specific behavior only
console.log('res stats block loaded');